import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ProgressBar as RBProgressBar } from 'react-bootstrap';
import { random } from 'lodash';

const generateRandomIncrement = () => 5 + random(0, 10);

class ProgressBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = { progress: 0, timeout: props.timeout };
  }

  componentDidMount() {
    const { timeout } = this.props;

    if (timeout > 0) {
      this.interval = setInterval(this.updateProgress, 1000);
    }
  }

  componentWillUnmount() {
    if (this.interval) {
      this.cancelUpdates();
    }
  }

  updateProgress = () => {
    const { timeout, progress } = this.state;
    // we update progress until reaching a simulated 80%. After that,
    // we stop and wait until timeout gets to 0
    const nextProgress =
      progress > 80 ? progress : progress + generateRandomIncrement();

    this.setState(
      {
        timeout: timeout - 1,
        progress: nextProgress
      },
      this.checkTimeout
    );
  };

  cancelUpdates = () => {
    clearInterval(this.interval);
  };

  checkTimeout = () => {
    const { timeout } = this.state;
    const { onTimeout, onTick } = this.props;

    onTick(timeout);

    if (timeout <= 0) {
      this.cancelUpdates();
      onTimeout();
    }
  };

  render() {
    const { completed } = this.props;
    const progress = completed ? 100 : this.state.progress;

    const className = classnames('tvt-progress-bar', {
      'tvt-progress-bar--complete': completed
    });

    return <RBProgressBar className={className} now={progress} />;
  }
}

ProgressBar.propTypes = {
  completed: PropTypes.bool,
  timeout: PropTypes.number,
  onTimeout: PropTypes.func,
  onTick: PropTypes.func
};

ProgressBar.defaultProps = {
  completed: false,
  timeout: 0,
  onTimeout: () => {},
  onTick: () => {}
};

export default ProgressBar;
